export default __webpack_public_path__ + "3cbad0b559f2491220a506b6179fd533.png";